import {Component, OnInit} from '@angular/core';
import {ApplyFormService} from "../../../../shared/services/apply-form.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute} from '@angular/router';
import {Location} from "@angular/common";
@Component({
    selector: 'app-program-fee',
    templateUrl: './program-fee.component.html',
    styleUrls: ['./program-fee.component.scss']
})
export class ProgramFeeComponent implements OnInit {
    currentPath: string;
    selectedTab: 'national' | 'international' = 'national';
    courses: any[] = []
    pcbData: any[] = []
    branches: any[] = []
    filteredCourses: any[] = []
    filterCoursesForm: FormGroup = new FormGroup({});

    constructor(
        private applyFormService: ApplyFormService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private location: Location) {
        this.route.data.subscribe(data => {
            if (data.title === 'International Program Fee') {
                this.selectedTab = 'international';
            } else this.selectedTab = 'national';
        })
        this.currentPath = this.location.path();
        this.getPcb()
    }

    ngOnInit(): void {
        this.filterCoursesForm = this.formBuilder.group({
            course_id: [''],
            branch_id: ['']
        })
    }

    toggleFeeType(type: 'semester' | 'yearly', course: any) {
        course.fee_type = type
    }

    getPcb(): void {
        this.applyFormService.pcb_mapping().subscribe(data => {
            this.getCourses(data.data)
        })
    }

    getCourses(data: any) {
        let allCourses = data
            .filter((item: any) =>
                item?.course?.id &&
                Array.isArray(item.fees) &&
                item.fees.some((fee: any) => +fee.session_id === 17)
            )
            .map((item: any) => ({
                ...item,
                result_type: item.result_type,
                fee_type: item.result_type === 'SEMESTER' ? 'semester' : 'yearly',
                fees: item.fees.filter((fee: any) => +fee.session_id === 17)
            }));

        allCourses.forEach((course: any) => {
            let exits = this.courses.find((item: any) => +course.course.id === +item.id)
            if (!exits) {
                this.courses.push({
                    id: course.course.id,
                    name: course.course.name,
                })
            }
        })

        allCourses.forEach((course: any) => {
            course.semester_fee = []
            for (let fee of course.fees) {
                fee.total_fee = (+fee?.tuition_fee || 0)
            }

            for (let fee of course.fees) {
                if (+fee?.year === 1) {
                    course.semester_fee.push({semester: 1, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 2, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 2) {
                    course.semester_fee.push({semester: 3, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 4, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 3) {
                    course.semester_fee.push({semester: 5, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 6, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 4) {
                    course.semester_fee.push({semester: 7, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 8, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 5) {
                    course.semester_fee.push({semester: 9, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 10, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 6) {
                    course.semester_fee.push({semester: 11, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 12, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 7) {
                    course.semester_fee.push({semester: 13, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 14, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 8) {
                    course.semester_fee.push({semester: 15, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 16, fee: fee.total_fee / 2})
                }
            }
        })

        this.pcbData = allCourses;
        this.filteredCourses = this.pcbData
    }

    getBranches() {
        let courseId = this.filterCoursesForm && this.filterCoursesForm.getRawValue() && this.filterCoursesForm.getRawValue().course_id || ''
        this.branches = []
        if (courseId) {
            this.branches = this.pcbData.filter((item: any) => +item.course.id === +courseId)
            if (this.branches.length > 0) {
                this.filteredCourses = this.branches
            } else {
                this.filteredCourses = this.pcbData
            }
        } else {
            this.filteredCourses = this.pcbData
        }
    }

    filterBranches() {
        let courseId = this.filterCoursesForm && this.filterCoursesForm.getRawValue() && this.filterCoursesForm.getRawValue().course_id || '';
        let branchId = this.filterCoursesForm && this.filterCoursesForm.getRawValue() && this.filterCoursesForm.getRawValue().branch_id || ''
        this.filteredCourses = []

        if (branchId) {
            if (branchId === 'general') {
                this.filteredCourses = this.pcbData.filter((item: any) => item?.branch === null && item.course?.id === +courseId)
            } else {
                this.filteredCourses = this.pcbData.filter((item: any) => item?.branch?.id === +branchId && item.course?.id === +courseId)
            }
        } else {
            this.filteredCourses = this.pcbData.filter((item: any) => item.course?.id === +courseId)
        }
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }
}
